/* 
    -- 配送先バリデーション --
    
    1. 必須制御
    2. 誤入力可能性アラート
*/

const alertCityField = (city) => {
    //  市区町村に対して
    //  入力が、”世田谷区 世田谷”で終わってるなど”丁目”が抜けている可能性を感知した場合、「この住所で正しいですか？」などのアラートがテキストホルダーの下に表示
    const cityValue = city.value;

    if(document.querySelector('.c-warning-text')){
        document.querySelector('.c-warning-text').remove();
    }

    // cityValueに半角数値及び全角数値が含まれていない場合、アラートを表示
    if(cityValue.length > 0 && cityValue.match(/[0-9０-９]/) === null){
        city.insertAdjacentHTML('afterend', `
            <small class="c-warning-text">この住所で正しいですか？</small>
        `);
    }
}

document.addEventListener('DOMContentLoaded', (event) => {
    // 他フォームの削除
    const url = new URL(window.location.href);
    const addressId=url.searchParams.get("address_id");
    if(addressId){
        const addresses = document.querySelectorAll('.normal-address');
        addresses.forEach(function(address) {
            if (address.dataset.address !== addressId) {
                address.remove();
            }
        });
    }

    const form = document.querySelector('form.h-adr');

    const lastName = form.querySelector('[name="address[last_name]"]'),
        firstName = form.querySelector('[name="address[first_name]"]'),
        zipCode = form.querySelector('[name="address[zip]"]'),
        province = form.querySelector('[name="address[province]"]'),
        city = form.querySelector('[name="address[city]"]'),
        phone = form.querySelector('[name="address[phone]"]'),
        errorTextArea = document.querySelector('.c-error-text-area');

    // 1. 必須制御
    form.addEventListener('submit', (event) => {
        const errorMsgList = [];

        errorTextArea.innerHTML = "";
        if(form.querySelectorAll(".is-error").length > 0){
            form.querySelectorAll(".is-error").forEach((element) => {
                element.classList.remove('is-error');
            });
        }

        // 名前
        if(lastName.value.length === 0 ){
            lastName.classList.add('is-error');
            errorMsgList.push("お名前（姓）を入力してください");
        }
        if(firstName.value.length === 0){
            firstName.classList.add('is-error');
            errorMsgList.push("お名前（名）を入力してください");
        }

        // 郵便番号
        if(zipCode.value.length === 0){
            zipCode.classList.add('is-error');
            errorMsgList.push("郵便番号を入力してください");
        }
        // 都道府県
        if(province.value.length === 0){
            province.classList.add('is-error');
            errorMsgList.push("都道府県を選択してください");
        }
        // 市区町村
        if(city.value.length === 0){
            city.classList.add('is-error');
            errorMsgList.push("市区町村を入力してください");
        }

        // 電話番号
        if(phone.value.length === 0){
            phone.classList.add('is-error');
            errorMsgList.push("電話番号を入力してください");
        }

        if(errorMsgList.length > 0){
            event.preventDefault();
            let errorHTML = ""
            errorMsgList.forEach((errorText) => {
                errorHTML += `<small class="c-error-text">${errorText}</small>`;
            });
            errorTextArea.innerHTML = errorHTML;
        }
    });

    // 2. 誤入力可能性アラート
    alertCityField(city);
    city.addEventListener('change', () => {
        alertCityField(city)
    });

    // 3. 郵便番号による自動入力
    zipCode.addEventListener("blur", function(event) {
        if(event.target.value && event.target.value.length > 0){
            const provinceAutoComplete = document.getElementById("province-for-autocomplete");
                
            let provinceOption = null;
            for (let i = 0; i < province.options.length; i++) {
                if (province.options[i].textContent === provinceAutoComplete.value) {
                    provinceOption = province.options[i];
                    break;
                }
            }

            if(provinceOption){
                province.value = provinceOption.value;
                alertCityField(city)
            }
        }
    
    });
});